<!-- <img src="/static/front_images/fast2.jpg" /> -->
<main>
    <img class="logo" src="/static/logo.svg" alt="Fjälltoppens logga" />
    <div class="description">
        <h2>Integritetspolicy</h2>
        <p>
            Fjälltoppens integritetspolicy är enkel: Vi samlar inte in några personuppgifter. Det är ett val som vi har
            gjort för att värna om din integritet på riktigt.
        </p>
        <p>Vi använder inte heller några icke-funktionella cookies på vår webbplats.</p>
    </div>
</main>

<svelte:head>
    <title>Integritetspolicy - Fjälltoppen</title>
</svelte:head>

<style>
    main {
        display: flex;
        align-items: center;
        width: 100%;
        flex-direction: column;
    }

    .logo {
        max-width: 400px;
    }

    .description {
        max-width: 500px;
    }
</style>
